export default __webpack_public_path__ + "assets/images/e71cadf2842d5bbe41377613edda2d67.svg";